import { render } from "./InfDetails.vue?vue&type=template&id=58504b3b&scoped=true"
import script from "./InfDetails.vue?vue&type=script&lang=js"
export * from "./InfDetails.vue?vue&type=script&lang=js"

import "./InfDetails.vue?vue&type=style&index=0&id=58504b3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58504b3b"]])

export default __exports__